import { addNamespace } from '@Utils/actions';
import { createAction } from '@reduxjs/toolkit';
import {
	ColumnFilterOptions,
	ColumnFilterValue,
	Pagination,
	ResolvedResponse,
	Sort2 as Sort,
	Sort2,
	Status,
	Translations,
} from '@innovyze/lib-am-common';
import { Edge as LeafConnection, Node as LeafNode } from 'react-flow-renderer';
import {
	TreeNode,
	ReactFlowDecisionTree,
	GetRehabTreeParams,
	ReactFlowSchema,
	NodeConditionParams,
	NodePositionParams,
	GetRehabActionsParams,
	RehabAction,
	ValidateRehabTreeParams,
	RunRehabTreeParams,
	RehabTreeValidation,
	RehabResults,
	RehabTreeId,
	RehabCostParams,
	RehabCost,
	rehabTreesPaginationDefault,
	RehabTreeList,
	ConfigObj,
	NewDecisionTree,
	AssetFilter,
} from '@Types';
import { GridFilterModel } from '@innovyze/stylovyze';
export const getRehabDetails = createAction('rehab/getRehabDetails');

export const getRiskDetailsDefaulted = () => getRehabDetails();

export const reloadRehabDetails = createAction(
	addNamespace('rehab/reloadRehabDetails'),
);

export const createRehabTree = createAction<TreeNode>(
	addNamespace('rehab/createRehabTree'),
);
export const createNewRehabTree = createAction<string>(
	addNamespace('rehab/createNewRehabTree'),
);
export const addNewNode = createAction<LeafNode>(
	addNamespace('rehab/addNewNode'),
);
export const addNewEdge = createAction<LeafConnection>(
	addNamespace('rehab/addNewEdge'),
);

export const setTab = createAction<string>(addNamespace('rehab/setTab'));
export const setCurrentTreeId = createAction<string>(
	addNamespace('rehab/setCurrentTreeId'),
);
export const setNewTree = createAction(addNamespace('rehab/setNewTree'));

export const getRehabTree = createAction<GetRehabTreeParams>(
	addNamespace('rehab/getRehabTree'),
);
export const getRehabTreeRejected = createAction(
	addNamespace('rehab/getRehabTreeRejected'),
);
export const getRehabTreeResolved = createAction<ReactFlowDecisionTree>(
	addNamespace('rehab/getRehabTree/resolved'),
);

export const getRehabTreeStatus = createAction<GetRehabTreeParams>(
	addNamespace('rehab/getRehabTreeStatus'),
);
export const getRehabTreeStatusRejected = createAction(
	addNamespace('rehab/getRehabTreeStatusRejected'),
);
export const getRehabTreeStatusResolved = createAction<string>(
	addNamespace('rehab/getRehabTreeStatus/resolved'),
);

export const getRehabTreeValidationStatus = createAction<GetRehabTreeParams>(
	addNamespace('rehab/getRehabTreeValidationStatus'),
);
export const getRehabTreeValidationStatusRejected = createAction(
	addNamespace('rehab/getRehabTreeValidationStatusRejected'),
);
export const getRehabTreeValidationStatusResolved = createAction<string>(
	addNamespace('rehab/getRehabTreeValidationStatus/resolved'),
);

export const getRehabTrees = createAction<Pagination>(
	addNamespace('rehabTrees/getRehabTrees'),
);
export const clearRehabTrees = createAction<Pagination>(
	addNamespace('rehabTrees/clearRehabTrees'),
);
export const clearRehabTreesDefault = () =>
	clearRehabTrees(rehabTreesPaginationDefault());
export const reloadRehabTrees = createAction(
	addNamespace('rehabTrees/reloadRehabTrees'),
);
export const getRehabTreesResolved = createAction<ResolvedResponse>(
	addNamespace('rehabTrees/getRehabTrees/resolved'),
);
export const getRehabTreesRejected = createAction<Status>(
	addNamespace('rehabTrees/getRehabTrees/rejected'),
);
export const changeRehabTreesSort = createAction<Sort2>(
	addNamespace('rehabTrees/sort'),
);
export const changeRehabTreesSlice = createAction<number>(
	addNamespace('rehabTrees/slice'),
);
export const changeRehabTreesPage = createAction<number>(
	addNamespace('rehabTrees/page'),
);
export const setRehabTreesIsBusy = createAction<boolean>(
	addNamespace('rehab/isBusy'),
);
export const setRehabTreesLoaded = createAction(addNamespace('rehab/isLoaded'));
export const renameRehabTree = createAction<{ treeId: string; name: string }>(
	addNamespace('rehab/renameRehabTree'),
);
export const setRehabTreesIsRenaming = createAction<boolean>(
	addNamespace('rehab/setRehabTreesIsRenaming'),
);
export const getRehabTreesList = createAction(
	addNamespace('rehabTrees/getRehabTreesList'),
);

export const getRehabTreesListResolved = createAction<RehabTreeList[]>(
	addNamespace('rehabTrees/getRehabTreesList/resolved'),
);

export const getRehabTreesListRejected = createAction<Status>(
	addNamespace('rehabTrees/getRehabTreesList/rejected'),
);

export const setRehabTreeNameError = createAction<string>(
	addNamespace('rehabTress/setRehabTreeNameError'),
);

export const setRefreshList = createAction<boolean>(
	addNamespace('rehab/setRefreshList'),
);

export const setNewTreeName = createAction<NewDecisionTree>(
	addNamespace('rehab/setNewTreeName'),
);
export const addNodeToNewTree = createAction<ReactFlowSchema>(
	addNamespace('rehab/addNodeToNewTree'),
);
export const setNodeCondition = createAction<NodeConditionParams>(
	addNamespace('rehab/setNodeCondition'),
);
export const setNodePosition = createAction<NodePositionParams>(
	addNamespace('rehab/setNodePosition'),
);
export const addRehabTree = createAction<{
	history: any;
	assetFilterId?: string;
}>(addNamespace('rehab/addRehabTree'));

export const saveRehabTree = createAction<string>('rehab/saveRehabTree');
export const deleteRehabTree = createAction<{
	treeId: string;
	refresh: () => void;
}>(addNamespace('rehab/deleteRehabTree'));

export const deleteRehabTreeResolved = createAction<{
	treeId: string;
}>(addNamespace('rehab/deleteRehabTreeResolved'));
export const deleteRehabTreeRejected = createAction(
	addNamespace('rehab/deleteRehabTreeRejected'),
);
export const addRehabTreeRejected = createAction(
	addNamespace('rehab/addRehabTreeRejected'),
);
export const addRehabTreeResolved = createAction(
	addNamespace('rehab/addRehabTree/resolved'),
);

export const getRehabActions = createAction<GetRehabActionsParams>(
	addNamespace('rehab/getRehabActions'),
);
export const getRehabActionsRejected = createAction(
	addNamespace('rehab/getRehabActionsRejected'),
);
export const getRehabActionsResolved = createAction<RehabAction[]>(
	addNamespace('rehab/getRehabActions/resolved'),
);

export const addRehabDeletedAction = createAction<string>(
	addNamespace('rehab/addRehabDeletedAction'),
);

export const addRehabAction = createAction<{
	rehabAction: RehabAction;
}>(addNamespace('rehab/addRehabAction'));
export const addRehabActionRejected = createAction(
	addNamespace('rehab/addRehabActionRejected'),
);
export const addRehabActionResolved = createAction<RehabAction>(
	addNamespace('rehab/addRehabAction/resolved'),
);
export const addNewRehabActionToTree = createAction<RehabAction | undefined>(
	addNamespace('rehab/addRehabAction/addToTree'),
);
export const updateRehabActionInTree = createAction<RehabAction | undefined>(
	addNamespace('rehab/updateRehabActionInTree'),
);

export const deleteRehabAction = createAction<string>(
	addNamespace('rehab/deleteRehabAction'),
);

export const deleteRehabActionResolved = createAction<string>(
	addNamespace('rehab/deleteRehabActionResolved'),
);
export const deleteRehabActionRejected = createAction(
	addNamespace('rehab/deleteRehabActionRejected'),
);

export const saveRehabAction = createAction<{
	rehabAction: RehabAction;
}>(addNamespace('rehab/saveRehabAction'));
export const saveRehabActionRejected = createAction(
	addNamespace('rehab/saveRehabActionRejected'),
);
export const saveRehabActionResolved = createAction<RehabAction>(
	addNamespace('rehab/saveRehabAction/resolved'),
);

export const validateRehabTree = createAction<ValidateRehabTreeParams>(
	addNamespace('rehab/validateRehabTree'),
);
export const validateRehabTreeRejected = createAction(
	addNamespace('rehab/validateRehabTreeRejected'),
);
export const validateRehabTreeResolved = createAction(
	addNamespace('rehab/validateRehabTreeResolved'),
);

export const runRehabTree = createAction<RunRehabTreeParams>(
	addNamespace('rehab/runRehabTree'),
);
export const runRehabTreeRejected = createAction(
	addNamespace('rehab/runRehabTreeRejected'),
);
export const runRehabTreeResolved = createAction(
	addNamespace('rehab/runRehabTreeResolved'),
);

export const setRefreshResults = createAction<boolean>(
	addNamespace('rehab/refreshResults'),
);
export const getRehabResult = createAction(
	addNamespace('rehab/getRehabResult'),
);
export const reloadRehabResult = createAction(
	addNamespace('rehab/reloadRehabResult'),
);
export const getRehabResultResolved = createAction<ResolvedResponse>(
	addNamespace('rehab/getRehabResult/resolved'),
);
export const getRehabResultRejected = createAction<Status>(
	addNamespace('rehab/getRehabResult/rejected'),
);
export const changePage = createAction<number>(
	addNamespace('rehabresult/page'),
);
export const changePagination = createAction<{ page?: number; slice?: number }>(
	addNamespace('rehabresult/paginationModel'),
);
export const clearScanId = createAction(
	addNamespace('rehabresult/clearScanId'),
);
export const changeSearch = createAction<string>(
	addNamespace('rehabresult/changeSearch'),
);
export const changeSort = createAction<Sort>(addNamespace('rehabresult/sort'));
export const setSelected = createAction<string[]>(
	addNamespace('rehabresult/selected/set'),
);
export const addSelected = createAction<string[]>(
	addNamespace('rehabresult/selected/add'),
);
export const removeSelected = createAction<string[]>(
	addNamespace('rehabresult/selected/remove'),
);
export const clearSelected = createAction(
	addNamespace('rehabresult/selected/clear'),
);
export const currentRow = createAction<number>(
	addNamespace('rehabresult/current/row'),
);
export const setRehabResultIsBusy = createAction<boolean>(
	addNamespace('rehabresult/isBusy'),
);
export const changeFilterSelect = createAction<ColumnFilterValue>(
	addNamespace('rehabresult/filterSelect'),
);
export const changeFiltersSelect = createAction<ColumnFilterValue[]>(
	addNamespace('rehabresult/filterSelect'),
);

export const updateColumnFilterSelectOptions =
	createAction<ColumnFilterOptions>(
		addNamespace('rehabresult/filterSelect/column/options'),
	);

export const translate = createAction<Translations>(
	addNamespace('rehabresult/translate'),
);

export const addRehabTreeValidationResult = createAction<RehabTreeValidation>(
	addNamespace('rehab/addRehabTreeValidationResult'),
);

export const changeTreeUpdateStatus = createAction(
	addNamespace('rehab/changeTreeUpdateStatus'),
);
export const lockAction = createAction<RehabResults>(
	addNamespace('rehabresult/lockAction'),
);

export const lockActionResolved = createAction(
	addNamespace('rehabresult/lockAction/resolved'),
);

export const lockActionRejected = createAction(
	addNamespace('rehabresult/lockAction/rejected'),
);

export const editAction = createAction<RehabResults>(
	addNamespace('rehabresult/editAction'),
);

export const editActionResolved = createAction(
	addNamespace('rehabresult/editAction/resolved'),
);

export const editActionRejected = createAction(
	addNamespace('rehabresult/editAction/rejected'),
);

export const updateRehabTreeStatus = createAction<string>(
	addNamespace('rehab/updateRehabTreeStatus'),
);

export const resetFilters = createAction(
	addNamespace('rehabresult/resetFilters'),
);

export const duplicateRehabTree = createAction<RehabTreeId>(
	addNamespace('rehab/duplicateRehabTree'),
);

export const duplicateRehabTreeRejected = createAction(
	addNamespace('rehab/duplicateRehabTreeRejected'),
);
export const duplicateRehabTreeResolved = createAction(
	addNamespace('rehab/duplicateRehabTreeResolved'),
);

export const setStartNodeId = createAction<string>(
	addNamespace('rehab/setStartNodeId'),
);

export const getRehabCost = createAction<RehabCostParams>(
	addNamespace('rehab/getRehabCost'),
);
export const getRehabCostResolved = createAction<RehabCost>(
	addNamespace('rehab/getRehabCost/resolved'),
);
export const getRehabCostRejected = createAction<Status>(
	addNamespace('rehab/getRehabCost/rejected'),
);

export const setAllRiskConfigModels = createAction<ConfigObj[]>(
	addNamespace('rehab/setAllRiskConfigModels'),
);

export const clearCurrentTree = createAction(
	addNamespace('rehab/clearCurrentTree'),
);

export const changeRehabResultsFilter = createAction<
	GridFilterModel | undefined
>(addNamespace('rehabresults/filter'));

export const getAssetFilters = createAction(
	addNamespace('asset/getAssetFilters'),
);
export const getAssetFiltersRejected = createAction(
	addNamespace('asset/getAssetFiltersRejected'),
);
export const getAssetFiltersResolved = createAction<AssetFilter[]>(
	addNamespace('asset/getAssetFiltersResolved'),
);
